import React, {useEffect} from 'react';

import { Container } from './styles';

export default ({ msg, visible, setVisible }) => {

  useEffect(() => {
    const interval = setTimeout(() => {
      setVisible(false)
    }, 3000);
    return () => clearInterval(interval);
  }, [visible, setVisible])

  return ( 
    <Container 
      className={visible ? 'visible' : ''}  
    >
      <h1> Aviso !!! </h1> 
      <p>{msg}</p>
    </Container>
  )
}
